import { JsonApiDataDecorator } from './JsonApiDataDecorator';
import { JsonApiRecordDecorator } from './JsonApiRecordDecorator';

export class JsonApiDecorator {
  constructor(store) {
    Object.keys(store).forEach(k => {
      if (store[k] && typeof store[k] === 'object' && store[k].data && store[k].data[0]) {
        this[k] = new JsonApiDataDecorator(store[k].data, this);
      }
    });
  }

  newObject(type) {
    return Object.assign(new JsonApiRecordDecorator(), { type });
  }
}
